import React from 'react';

import classnames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

const ClassListViewDescription = ({ className }) => {
  const classes = classnames('_text-gray-600 _font-weight _mt-0', className);

  return (
    <p className={classes}>
      <I18n label="class_manager.class_list.description" checkOnlineEvent />
    </p>
  );
};

ClassListViewDescription.propTypes = {
  className: PropTypes.string
};

export default ClassListViewDescription;
